import Commons from '../../../../Services/Common/Common';

export const SAT_BASIC_07_Schema = {
  fields: {
    userNm: { initial: '', label: '성명' }, // 성명
    depNm: { initial: '', label: '소속(팀명)' }, // 소속
    position: { initial: '', label: '직급' }, // 직급
    etcEduNm: { initial: '', label: '교육명' }, // 교육명
    eduCount: { initial: 0, label: '등록교육수' }, // 등록교육수
    completeCount: { initial: 0, label: '이수완료건' }, // 이수완료건
    noCompleteCount: { initial: 0, label: '미이수건' }, // 미이수건
  },

  mapper: {
    search1: {
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd || ''),
      StartYear: (_, context) =>
        Commons.EncryptAES(context.search?.year.toString()) || '',
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText || ''),
    },
    search2: {
      UserId: (_, context) => context.userInfo?.userid || '',
    },

    save1: {
      TpaUserId: (row) => Commons.EncryptAES(row.tpaUserId || '') || '',
      AlarmGubun: (row) => Commons.EncryptAES(row.alarmGubun || '') || '',
      AlarmYn: (row) => Commons.EncryptAES(row.alarmYn || '') || '',
      CalId: (row) =>
        Commons.EncryptAES(row.calId ? row.calId.toString() : '0') || '',
      UpdateId: (_, context) => context.userInfo?.userid || '',
    },
  },
};
